import axios from 'axios'

export default {
  namespaced: true,
  state: {
    versements: [],
  },
  mutations: {
    SET_VERSEMENTS(state, _versements) {
      state.versements = _versements
    },
    ADD_ALL_VERSEMENTS(state, _versements) {
      _versements.forEach((versement) => {
        state.versements.push(versement)
      })
    },
    REPLACE_VERSEMENT(state, _versement) {
      let i = state.versements.findIndex((v) => v.versementId === _versement.versementId)
      if (i > -1) {
        state.versements[i] = _versement
      }
    },
    REMOVE_VERSEMENT(state, _versementsToRemove) {
      let i = state.versements.findIndex((v) => v.versementId === _versementsToRemove.versementId)
      if (i > -1) {
        state.versements.splice(i, 1)
      }
    },
  },
  getters: {
    getVersements: (state) => {
      return state.versements.sort((a, b) => (a.dateDeVersement < b.dateDeVersement ? -1 : 1))
    },
    getVersementsParDates: (state) => {
      let mensualites = []
      state.versements.forEach((versement) => {
        let index = mensualites.findIndex((m) => m.date === versement.dateDeVersement)
        if (index > -1) {
          mensualites[index].versements.push(versement)
        } else {
          mensualites.push({
            date: versement.dateDeVersement,
            versements: [versement],
          })
        }
      })
      mensualites.sort((a, b) => (a.date < b.date ? -1 : 1))
      return mensualites
    },
  },
  actions: {
    obtenirVersementsUsagerPourMoisEtEtablissement({ commit }, _obtenirVersementsUsagerPourMoisEtEtablissementComand) {
      return axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/versement`, {
          params: _obtenirVersementsUsagerPourMoisEtEtablissementComand,
        })
        .then((response) => {
          commit('SET_VERSEMENTS', response.data)
          return response.data
        })
    },
    obtenirVersementsParEtablissementADate({ commit }, _obtenirVersementsParEtablissementADateCommand) {
      return axios
        .get(`${process.env.VUE_APP_URL_BACK_SERENITY}/versement/aDate`, {
          params: _obtenirVersementsParEtablissementADateCommand,
        })
        .then((response) => {
          commit('SET_VERSEMENTS', response.data)
          return response.data
        })
    },
    preparerVersementMultidate({ commit }, _preparerVersementMultidateAIMCommand) {
      return axios
        .post(`${process.env.VUE_APP_URL_BACK_SERENITY}/versement/multidate`, _preparerVersementMultidateAIMCommand)
        .then((response) => {
          commit('ADD_ALL_VERSEMENTS', response.data)
          return response.data
        })
    },
    declarerCommeVerse({ commit }, _versementId) {
      return axios.put(`${process.env.VUE_APP_URL_BACK_SERENITY}/versement/${_versementId}/verser`).then((response) => {
        commit('REPLACE_VERSEMENT', response.data)
        return response.data
      })
    },
    supprimerVersement({ commit }, _versementASupprimer) {
      return axios
        .delete(`${process.env.VUE_APP_URL_BACK_SERENITY}/versement/${_versementASupprimer.versementId}`)
        .then((response) => {
          if (response.status === 200) {
            commit('REMOVE_VERSEMENT', _versementASupprimer)
          }
        })
    },
  },
}
